const getDashboardCustomizationFlieds = [
  {
    title: "Background Color",
    type: "color",
    reduxKey: "dashBgColor",
    defaultValue: "#ffffff",
    colorType: "bg",
  },
  {
    title: "Heading Color",
    type: "color",
    reduxKey: "headerColor",
    defaultValue: "#000000",
    colorType: "text",
  },
  {
    title: "Grid",
    type: "checkbox",
    showUnderLine: false,
    defaultValue: true,
    reduxKey: "grid",
    isParent: true,
  },
];
export { getDashboardCustomizationFlieds };
